
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Was sagen die Epidemiologen?`}</h3>
    <p><strong parentName="p">{`Der Vorteil des digitalen Contact-Tracing`}</strong>{`, auch Proximity Tracing genannt,
liegt darin, dass die Kontakte schneller identifiziert und in Quarantäne
versetzt werden können.`}</p>
    <p><strong parentName="p">{`Klassisches Contact-Tracing`}</strong>{` mit
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/covid-19-schafft-neue-jobs-684316949243"
      }}>{`Mitarbeitern`}</a>{`
der Gesundheitsämter und Spitäler, die durch
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/zuerich-betreibt-eine-virus-detektei-246931356434"
      }}>{`fleissiges Nachfragen`}</a>{`
alle Kontakte nachverfolgen, `}<strong parentName="p">{`bleibt weiterhin wichtig`}</strong>{` – besonders für alle,
die die App nicht nutzen. Es ist jedoch aufwendig und langsam: Meistens verliert
man wichtige Stunden oder sogar Tage, bis alle Kontakte gefunden und informiert
werden können.`}</p>
    <p>{`Experten der Universität Oxford haben in einem
`}<a parentName="p" {...{
        "href": "https://science.sciencemag.org/content/early/2020/04/09/science.abb6936"
      }}>{`Paper`}</a>{`
in der Zeitschrift «Science» gezeigt, wie wichtig `}<strong parentName="p">{`Geschwindigkeit`}</strong>{` ist bei
der Isolierung von Covid-19-Erkrankten sowie bei der Versetzung in Quarantäne
von Kontakten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;